import { FC, useRef, useEffect, useLayoutEffect, useState } from 'react';
import classnames from 'classnames';

import { ProgressBarSegmentedProps } from '@hh.ru/magritte-ui-progress-bar/types';

import styles from './progress-bar.less';

const STYLE_TO_CSS = {
    accent: styles.segmentedContainerStyleAccent,
    positive: styles.segmentedContainerStylePositive,
    special: styles.segmentedContainerStyleSpecial,
};
export const SegmentedProgressBar: FC<ProgressBarSegmentedProps> = ({
    segments,
    progress,
    style = 'accent',
    'data-qa': dataQA = 'progress',
    'aria-label': ariaLabel,
}) => {
    const prevProgress = useRef(progress);
    const [animationTimeout, setAnimationTimeout] = useState(0);
    useEffect(() => {
        prevProgress.current = progress;
    }, [progress]);

    useLayoutEffect(() => {
        const animationTimeoutElement = document.createElement('div');
        animationTimeoutElement.classList.add(styles.progressAnimationTimeout);
        document.body.appendChild(animationTimeoutElement);
        const style = window.getComputedStyle(animationTimeoutElement);
        const animationTimeout = parseInt(style.getPropertyValue(`--animation-duration`), 10);
        if (Number.isInteger(animationTimeout)) {
            setAnimationTimeout(animationTimeout);
        }
        document.body.removeChild(animationTimeoutElement);
    }, []);

    return (
        <div
            className={classnames(styles.segmentedContainer, STYLE_TO_CSS[style])}
            data-qa={dataQA}
            role="progressbar"
            aria-valuemin={0}
            aria-valuemax={segments}
            aria-valuenow={progress}
            aria-label={ariaLabel}
        >
            {[...Array(segments).keys()].map((_, i) => {
                let delay = 0;
                const direction = progress - prevProgress.current >= 0 ? 0 : -1;
                const startSelection = prevProgress.current + direction;
                if (i === startSelection) {
                    delay = 0;
                } else {
                    delay = Math.abs(i - startSelection) * animationTimeout;
                }
                return (
                    <div
                        key={i}
                        className={classnames(styles.segment, {
                            [styles.filled]: i < progress,
                        })}
                        style={{ transitionDelay: `${delay}ms` }}
                        data-qa="progress-segment"
                    />
                );
            })}
        </div>
    );
};
